import data from '../../../../data/basic.json';
export class InitPointsPositioningAdapter {
    constructor() {
        this._points = [...document.querySelectorAll('.point')];
    }

    init(source) {
        if (source === 'desktop') {
            this._points.forEach((point, index) => {
                point.setAttribute('style', `left: ${data.points[index].x}%; top: ${data.points[index].y}%;`);
            });
        } else {
            this._points.forEach((point, index) => {
                point.setAttribute('style', `left: ${data.points[index].xm}%; top: ${data.points[index].ym}%;`);
            });
        }
    }
}
